import { TChatKitConstants, TTranslationFunction } from '../_lib/types'

/**
 * Get localized ChatKit constants for Business Plan Generator
 * @param t - Translation function from useTranslations('business-plan')
 * @returns Localized ChatKit constants
 */
export function getChatKitConstants(
  t: TTranslationFunction,
): TChatKitConstants {
  return {
    greeting: t('chatkit_greeting'),
    starterPrompts: [
      {
        label: t('starter-prompts.create-from-scratch.label'),
        prompt: t('starter-prompts.create-from-scratch.prompt'),
        icon: 'sparkle',
      },
      {
        label: t('starter-prompts.improve-existing.label'),
        prompt: t('starter-prompts.improve-existing.prompt'),
        icon: 'lightbulb',
      },
      {
        label: t('starter-prompts.get-templates.label'),
        prompt: t('starter-prompts.get-templates.prompt'),
        icon: 'book-open',
      },
    ],
    placeholder: t('chatkit_placeholder'),
  }
}
